import { ResourceCard } from "../../../ui/Learning/ResourceCard.jsx";
import { ResourceCardLayout } from "../../../ui/Learning/ResourceCardLayout.jsx";

import { isDisabled } from "../utils/util.js";

export default function SubjectList({loading, subjects = [], onClick}) {
  const getDescription = (counts = 0) => {
    return `${counts > 1 ? "Chapters" : "Chapter"} ${counts}`;
  };
  return (
    <ResourceCardLayout
      loading={loading}
      total={subjects.length}
      message="0 Subjects to display"
    >
      {subjects.map((subject) => (
        <ResourceCard
          key={subject._id}
          name={subject.subject}
          description={getDescription(subject?.subjectData?.totalChapters)}
          thumbnail={subject?.subjectData?.thumbnail}
          onClick={() => onClick(subject)}
          isDisabled={
            isDisabled(subject?.subjectData?.chapters) ||
            subject?.subjectData?.disabled
          }
        />
      ))}
    </ResourceCardLayout>
  );
}
